import { createFileRoute } from "@tanstack/react-router";
import { Organization } from "../../../components/app/admin/projects/Organization";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { adminRouterClient } from "../../../lib/adminRouterClient";

export const Route = createFileRoute("/admin/projects/")({
  component: RouteComponent,
});

function RouteComponent() {
  const queryClient = useQueryClient();

  const { data: organizations } = useQuery(
    {
      queryKey: ["admin-organizations"],
      queryFn: async () => {
        const res = await adminRouterClient.organizations.$get();
        return await res.json();
      },
    },
    queryClient
  );

  return (
    <div className="container max-w-none flex h-full w-full flex-col items-start gap-12 bg-default-background py-12">
      <div className="flex w-full flex-col items-start gap-6">
        <div className="flex w-full items-center gap-6 justify-between">
          <span className="whitespace-pre-wrap text-heading-1 font-heading-1 text-default-font">
            {"Projects"}
          </span>
        </div>
        <div className="flex w-full flex-col items-start gap-12">
          {organizations?.map((organization) => (
            <Organization
              key={organization.id}
              id={organization.id}
              name={organization.name}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
